import localforage from 'localforage'
import _ from 'lodash'

class Fluide {
    static calcTonnage(fluide, charge) {
        return round(fluide.gwp * charge / 1000, 4)
    }

    getFluide(id, callback) {
        this.getList(function (res) {
            callback(_.find(res, ['id', id]))
        })
    }

    getList(callback) {
        localforage
            .getItem('listFluides')
            .then(fluides => {
                fluides = JSON.parse(fluides);
                let f = _.sortBy(fluides.noFiltre, (item) => {
                    return (item.rang !== undefined && item.rang !== null) ? item.rang : item.nom;
                });
                callback(f)
            }).catch()
    }

    getListFiltre(callback) {
        localforage
            .getItem('listFluides')
            .then(fluides => {
                fluides = JSON.parse(fluides);
                let f = _.sortBy(fluides.filtre, (item) => {
                    return (item.rang !== undefined && item.rang !== null) ? item.rang : item.nom;
                });
                callback(f)
            }).catch()
    }
}

export default Fluide



// WEBPACK FOOTER //
// ./src/js/models/Fluide.js